import { CommonModule } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NavigationExtras, Router } from '@angular/router';
import { IonInfiniteScroll, IonRefresher, ModalController } from '@ionic/angular/standalone';
import { IonHeader, IonToolbar, IonBackButton, IonTitle, IonButton, IonIcon, IonContent, IonRefresherContent, IonList, IonItem, IonLabel, IonInfiniteScrollContent } from '@ionic/angular/standalone';
import { Store } from "@ngrx/store";
import { Subject, takeUntil } from "rxjs";
import { CollectionTemplateRepository } from "../../+state/collection-template-repository.service";
import { PaginatedResponse } from "../../../../interface/PaginatedResponse";
import { AuthSelectors } from "../../../authentication";
import { CollectionTemplate } from '../../models/CollectionTemplate';
import { CollectionTemplateService } from '../../services/collection-template.service';
import { CreateCollectorTemplatePage } from '../create-collector-template/create-collector-template.page';
import { SexyModule } from '@qid/sexy';

@Component({
  selector: 'app-collection-templates',
  templateUrl: './collection-templates.page.html',
  styleUrls: ['./collection-templates.page.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    SexyModule,
    IonHeader,
    IonToolbar,
    IonBackButton,
    IonTitle,
    IonButton,
    IonIcon,
    IonContent,
    IonRefresher,
    IonRefresherContent,
    IonInfiniteScroll,
    IonInfiniteScrollContent,
    IonList,
    IonItem,
    IonLabel
  ]
})
export class CollectionTemplatesPage implements OnInit {
  @ViewChild(IonInfiniteScroll) infiniteScroll: IonInfiniteScroll;

  @ViewChild('refresher') refresher: IonRefresher;
  public paginatedData: PaginatedResponse<CollectionTemplate> = {docs: []};
  public collectionTemplates$ = this.collectionTemplateRepository.allCollectionTemplates;
  public lastUpdateTime = null;
  public pageClosed$ = new Subject();

  constructor(
    private collectionTemplateService: CollectionTemplateService,
    private collectionTemplateRepository: CollectionTemplateRepository,
    private router: Router,
    private modalController: ModalController,
    private store: Store
  ) {
  }

  ngOnInit() {
  }

  ionViewDidEnter() {
    this.store.select(AuthSelectors.selectActiveAccount)
      .pipe(takeUntil(this.pageClosed$))
      .subscribe(() => {
        this.collectionTemplateRepository.init()
      })
  }

  ionViewDidLeave() {
    this.pageClosed$.next(null);
    this.pageClosed$.complete()
  }

  async fetchTemplates(page: number = 1) {
    this.paginatedData = await this.collectionTemplateService.readAll(page);
  }

  public viewTemplate(template) {
    const extras: NavigationExtras = {
      state: {
        template: template,
      },
    };
    this.router.navigateByUrl('view-collection-templateId', extras);
  }

  async createCollectionTemplate() {
    const modal = await this.modalController.create({
      component: CreateCollectorTemplatePage,
    });
    await modal.present();
    const data = await modal.onDidDismiss();
    if (data.data.template && data.data.template._id) {
      await this.fetchTemplates();
      this.viewTemplate(data.data.template);
    }
  }

  async swipeToRefresh() {
    await this.fetchTemplates();
    this.refresher.complete();
  }


  async infiniteLoad($event: any) {
    if (!this.paginatedData.hasNext) {
      this.infiniteScroll.complete();
      return;
    }
    const newPageData: PaginatedResponse<CollectionTemplate> =
      await this.collectionTemplateService.readAll(++this.paginatedData.page);
    newPageData.docs = this.paginatedData.docs.concat(newPageData.docs);
    this.paginatedData = newPageData;
    this.infiniteScroll.complete();
  }
}
